import { render, staticRenderFns } from "./ConfiguracoesExtras.vue?vue&type=template&id=73ebd60d&"
import script from "./ConfiguracoesExtras.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports